import { api } from '../services/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchRegulationCategories = createAsyncThunk(
    'regulations/fetchCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/regulations/categories');
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to fetch regulation categories');
        }
    }
);

export const fetchRegulations = createAsyncThunk(
    'regulations/fetchRegulations',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/regulations/regulations');
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to fetch regulations');
        }
    }
);

const regulationSlice = createSlice({
    name: 'regulations',
    initialState: {
        error: null,
        status: 'idle',
        categories: [],
        regulations: [],
        categoriesStatus: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Categories
            .addCase(fetchRegulationCategories.pending, (state) => {
                state.categoriesStatus = 'loading';
                state.error = null;
            })
            .addCase(fetchRegulationCategories.fulfilled, (state, action) => {
                state.categoriesStatus = 'succeeded';
                state.categories = action.payload;
            })
            .addCase(fetchRegulationCategories.rejected, (state, action) => {
                state.categoriesStatus = 'failed';
                state.error = action.payload || action.error.message;
            })
            // Regulations
            .addCase(fetchRegulations.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchRegulations.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.regulations = action.payload;
            })
            .addCase(fetchRegulations.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const selectRegulationError = (state) => state.regulations.error;
export const selectRegulations = (state) => state.regulations.regulations;
export const selectRegulationCategories = (state) => state.regulations.categories;
export const selectRegulationStatus = (state) => state.regulations.status || state.regulations.categoriesStatus;

export default regulationSlice.reducer;
